import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    title: 'Protocolo de Enfriamiento Distal',
    desc: 'El truco térmico para bajar 1.5°C tu temperatura interna y caer en sueño profundo rápido.'
  }, {
    title: 'Dieta de Luz Azul',
    desc: "Cómo configurar tus dispositivos y tu hogar para que dejen de gritarle 'es mediodía' a tu cerebro a las 10 PM."
  }, {
    title: 'El Ritual de Desconexión de 20 Minutos',
    desc: 'Tres pasos exactos para desarmar el sistema nervioso simpático antes de tocar la almohada.'
  }, {
    title: 'Protocolo de Rescate 3 AM',
    desc: 'Qué hacer exactamente cuando te despiertas a mitad de la noche para volver a dormir en menos de 10 minutos.'
  }, {
    title: 'Guía de Suplementación Inteligente',
    desc: 'Lo único que realmente ayuda (y qué basura debes dejar de comprar hoy mismo).'
  }];
  return <section className="py-10 px-4 md:px-8 bg-[#0f1628]/40 border-y border-cyan-500/10" data-id="element-160">
      <div className="max-w-5xl mx-auto" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-162">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-163">
            Lo que obtienes dentro del Código
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-164">
          {deliverables.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} viewport={{
          once: true
        }} className={`bg-[#0f1628]/50 border border-cyan-500/20 p-6 rounded-xl hover:bg-[#0f1628]/70 transition-all ${i === deliverables.length - 1 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-165">
              <div className="flex items-start gap-4" data-id="element-166">
                <CheckCircle2 className="w-6 h-6 text-cyan-400 shrink-0 mt-1" data-id="element-167" />
                <div data-id="element-168">
                  <h3 className="text-lg font-bold text-white mb-2" data-id="element-169">
                    {item.title}
                  </h3>
                  <p className="text-[#b8c4d6]" data-id="element-170">{item.desc}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}